import { VALID_AWS_REGIONS } from "@p0security/integrations-aws-frontend";

export const VALID_AWS_SSM_REGIONS = VALID_AWS_REGIONS;

// All regions with VM support in Azure
// https://azure.microsoft.com/en-us/explore/global-infrastructure/products-by-region/table
export const VALID_AZURE_VM_REGIONS = [
  // United States
  "eastus",
  "eastus2",
  "southcentralus",
  "westus2",
  "westus3",
  "centralus",
  "northcentralus",
  "westus",
  "westcentralus",
  "eastusstg",
  "southcentralusstg",

  // Canada
  "canadacentral",
  "canadaeast",

  // Europe
  "northeurope",
  "westeurope",
  "uksouth",
  "ukwest",
  "francecentral",
  "francesouth",
  "germanywestcentral",
  "germanynorth",
  "switzerlandnorth",
  "switzerlandwest",
  "italynorth",
  "norwayeast",
  "norwaywest",
  "polandcentral",
  "spaincentral",
  "swedencentral",

  // Asia Pacific
  "southeastasia",
  "eastasia",
  "australiaeast",
  "australiasoutheast",
  "australiacentral",
  "australiacentral2",
  "japaneast",
  "japanwest",
  "koreacentral",
  "koreasouth",
  "centralindia",
  "southindia",
  "westindia",
  "jioindiacentral",
  "jioindiawest",

  // Middle East
  "uaenorth",
  "uaecentral",
  "israelcentral",
  "qatarcentral",

  // Africa
  "southafricanorth",
  "southafricawest",

  // South America
  "brazilsouth",
  "brazilsoutheast",
  "brazilus",

  // Mexico
  "mexicocentral",
];

export const sshCspKeys = ["azure", "aws", "gcloud", "self-hosted"] as const;
